/*
** ThemeServices
*/
import config from "../config";

const THEME_API_URL = config?.api?.endpoints?.WP_SINGLE_SCHOOL_API;

/**
 * Fetch theme and onboarding data from API
 */
export const fetchSchoolData = async (schoolId: string) => {
  try {
    const response = await fetch(`${THEME_API_URL}/${encodeURIComponent(schoolId)}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",

      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch theme data: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error while fetching theme data:", error);
    return null;
  }
};
